
import ActivityCard from "./ActivityCard";
import { Activity } from "./types";

interface ActivityListProps {
  activities: Activity[];
  title?: string;
  isLoading?: boolean;
}

const ActivityList = ({ activities, title, isLoading }: ActivityListProps) => {
  if (isLoading) {
    return (
      <div className="py-8 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        <p className="mt-2 text-sm text-muted-foreground">Loading activities...</p>
      </div>
    );
  }

  if (activities.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {title && <h3 className="text-lg font-semibold my-6">{title}</h3>}
      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="w-full">
            <ActivityCard
              title={activity.name}
              description={activity.description}
              imageUrl={activity.thumbnailUrl}
              imageUrls={activity.imageUrls}
              price={`${activity.minPrice}`}
              currency={activity.currency}
              bookingUrl={activity.url}
              rating={activity.ratingAverage}
              numberOfRatings={activity.numberOfRatings}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityList;
